import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
    name: 'thousandsFormat'
} )
export class ThousandsFormatPipe implements PipeTransform {

    transform ( value: any, args?: any ): any {
        // return ( value + '' ).match( new RegExp( '.{1,3}', 'g' ) ).join( ' ' );
        return ( value + '' ).replace( /\B(?=(\d{3})+(?!\d))/g, ' ' );
    }

}
